// extracted by mini-css-extract-plugin
export default {"about":"About_about__FBkNT","about_content":"About_about_content__wqxPw","about_content__img":"About_about_content__img__r+whX"};